import { createFileRoute } from '@tanstack/react-router';
import { ErpRolesCatalog } from '@/features/workforce/ErpRolesCatalog';

export const Route = createFileRoute('/_app/organization/job-roles')({ component: ErpRolesCatalog });

/*
 * I ruoli aziendali in MaeDesign: elenco filtrabile per azienda, ricerca, stato, e il
 * dettaglio che crea, modifica ed elimina — con il profilo permessi in chiaro sulla riga,
 * che è la cosa che distingue due ruoli con lo stesso nome.
 *
 * Prima era una `ResourceListPage` con un `QuickCreateButton`: una tabella generica che non
 * sapeva del profilo (la relationship non passa dai campi a schema), quindi ogni ruolo creato
 * da qui nasceva senza permessi. Il componente sta in `features/workforce/`, dove vive il
 * dominio, e questa rotta resta il solo punto di ingresso.
 */
